/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
const options = {
	KEYMAP: {
		'renewal-one': 'Renewal Reminder Email',
		welcome: 'Welcome Email',
		payment_error: 'Payment Error Email',
		payment_receipt: 'Payment Receipt'
	},
	EMAIL_TYPE: [
		{
			db_key: 'renewal-one',
			display: 'Renewal Reminder Email'
		},
		{
			db_key: 'welcome',
			display: 'Welcome Email'
		},
		{
			db_key: 'payment_error',
			display: 'Payment Error Email'
		},
		{
			db_key: 'payment_receipt',
			display: 'Payment Receipt Email'
		}
	],
	EMAIL_FREQUENCY: [
		{
			db_key: 'frequency',
			value: 90,
			display: '3 months before'
		},
		{
			db_key: 'frequency',
			value: 30,
			display: '1 month before'
		},
		{
			db_key: 'frequency',
			value: 14,
			display: '2 weeks before'
		},
		{
			db_key: 'frequency',
			value: 7,
			display: '1 week before'
		},
		{
			db_key: 'frequency',
			value: 3,
			display: '3 days before'
		},
		{
			db_key: 'frequency',
			value: 1,
			display: '1 day before'
		}
	]
};
export default options;
